import MapViewResults from './map-view-results'

export default MapViewResults
